import type { Odds } from '@swf/generated/types/api/sports';

import type { MarketId } from './market';
import type { SelectionId } from './selection';

export type Handicap = number;

export interface RunnerId {
  marketId: MarketId;
  selectionId: SelectionId;
}

export enum RunnerResultType {
  HOME = 'HOME',
  AWAY = 'AWAY',
  DRAW = 'DRAW',
  OVER = 'OVER',
  UNDER = 'UNDER',
  LINE = 'LINE',
  SCORE = 'SCORE',
  NO_GOAL = 'NO_GOAL'
}

export interface Runner {
  handicap?: Handicap;
  previousWinRunnerOdds: Odds[];
  runnerName: string;
  runnerStatus: RunnerStatus;
  selectionId: SelectionId;
  sortPriority: number;
  winRunnerOdds?: Odds;
  resultType?: RunnerResultType;
  rating123?: number;
  ratingStars?: number;
  comments?: string;
  form?: string;
  rating?: number;
  daysOff?: number;
  horse?: { age?: number };
}

export type Runners = [Runner, ...Runner[]];

export interface RunnerUpdate {
  handicap?: Handicap;
  previousWinRunnerOdds: Odds[];
  runnerId: RunnerId;
  runnerStatus: RunnerStatus;
  winRunnerOdds?: Odds;
}

export enum RunnerStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  REMOVED = 'REMOVED'
}
